import React, { useState } from 'react';
import { inject, observer } from 'mobx-react';
import { RootStore, meeting } from '@/models';
import s from './index.less';
import { Popover, Radio, RadioChangeEvent } from 'antd';
import HoverIcon from '../BarragePanel/components/HoverIcon';
import { MODE } from '@/models/meeting';
import gridView from '@/assets/grid_view.svg';
import lecturerView from '@/assets/lecturer_view.svg';
import classNames from 'classnames';
import { useIntl } from 'umi';
import { Icon } from '@/components';

interface Props extends Partial<Pick<RootStore, 'meeting' | 'reaction'>> {
  meeting?: RootStore['meeting'];
  onChange: (value: string) => void;
  value: MODE;
}
const ReactionBtn: React.FC<Props> = inject(({ store }) => {
  return {
    meeting: store.meeting,
  };
})(
  observer((props) => {
    const { value, onChange } = props;
    const [open, setOpen] = useState(false);
    const { formatMessage } = useIntl();
    const handleChange = (e: RadioChangeEvent) => {
      onChange(e.target.value as MODE);
      setOpen(false);
    };
    const handleOpenChange = (newOpen: boolean) => {
      setOpen(newOpen);
    };

    const selectPanel = (
      <div className={s.panel}>
        <div className="item">
          <Radio.Group onChange={handleChange} value={value} className={s.radioGroup}>
            {!meeting?.screenUid && (
              <Radio
                value={MODE.GRID}
                className={classNames(s.radio, value === MODE.GRID ? s.active : '')}
              >
                <span className={s.title}>{formatMessage({ id: 'grid' })}</span>
                <img src={gridView} className={s.view} />
              </Radio>
            )}

            <Radio
              value={MODE.LECTURER}
              className={classNames(s.radio, value === MODE.LECTURER ? s.active : '')}
            >
              <span className={s.title}>{formatMessage({ id: 'lecture' })}</span>
              <img src={lecturerView} className={s.view} />
            </Radio>
          </Radio.Group>
        </div>
      </div>
    );

    return (
      <Popover
        overlayClassName="oj7YZbAO5p"
        autoAdjustOverflow
        placement="bottomRight"
        align={{ offset: [150, -12] }}
        content={selectPanel}
        trigger={['click']}
        open={open}
        onOpenChange={handleOpenChange}
      >
        <div className={s.hoverIcon}>
          <Icon name="icon-view" mode="symbol" size={16} className={s.icon}></Icon>
        </div>
      </Popover>
    );
  })
);

export default ReactionBtn;
